import React, { useEffect, useRef } from "react";
import styles from "./search.module.css";

const Search = ({ flows, filteredFlows, filterFlows, focusedItem }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    inputRef.current.focus();
  }, []);

  useEffect(() => {
    if (inputRef.current?.value === "") {
      filterFlows(flows);
    }
  }, [inputRef.current?.value]);

  useEffect(() => {
    if (inputRef.current !== document.activeElement) {
      inputRef.current.value = "";
      inputRef.current.focus();
    }

    if (!focusedItem) {
      return;
    }

    const items = focusedItem?.slice(-2);
    // order items. including '-' in the string should be in end of the array
    items?.sort((a, b) => {
      if (a.includes("-")) {
        return 1;
      } else {
        return -1;
      }
    });
    console.log("items ::", items);
    let brand = items[0];
    console.log("brand ::", brand);

    let searchPlaceholder = brand ? "" : inputRef.current.value;

    if (items) {
      //inputRef.current.value = items.join(">");

      searchPlaceholder += items.length ? brand + ">" : "";

      if (items.length > 1) {
        try {
          const indexes = items[1].split("-").map((index) => {
            return isNaN(parseInt(index)) ? null : parseInt(index);
          });

          console.log("indexes ::", indexes, filteredFlows);

          const brandFlows = filteredFlows.filter(
            (flow) => flow.brand === brand
          )[0]?.transformed_flows;

          if (!brandFlows) {
            return;
          }

          console.log("brandFlows ::", brandFlows);

          const flowName =
            Object.keys(brandFlows).filter(
              (flowName, j) => j === indexes[1]
            )[0] || "";

          searchPlaceholder += `${flowName}`;
        } catch (error) {
          console.log("error ::", error);
          searchPlaceholder = inputRef.current.value;
        }
      }
    }
    inputRef.current.value = searchPlaceholder;
  }, [focusedItem]);

  const handleSearch = (e) => {
    const searchValue = e.target.value;

    /**
     * searchValue could a basic string. if it is, we need to filter the flows by brand, trnasformed_flows[x], and transformed_flows[x].vesion
     * it could be a string with '>' in it. if could be one, two, or three '>'s. if it is, before the '>' is the brand or the transformed_flows[x] or transformed_flows[x].version. after the '>' is the search value, so we need to filter by that
     */

    let filteredFlows = flows;

    if (searchValue.includes(">")) {
      // filter with brand and transformed_flows[x]
      // brand is the first item in the array
      // transformed_flows[x] is the second item in the array

      const searchValues = searchValue.split(">");
      const brand = searchValues[0];
      const flowName = searchValues[1];

      filteredFlows = flows.filter((flow) => {
        return flow.brand.toLowerCase().includes(brand.toLowerCase());
      });

      if (flowName && flowName.length > 0) {
        console.log("flowName ::", flowName);
        filteredFlows = filteredFlows.map((flow) => {
          return {
            ...flow,
            transformed_flows: Object.keys(flow.transformed_flows).reduce(
              (obj, key) => {
                if (key.toLowerCase().includes(flowName.toLowerCase())) {
                  obj[key] = flow.transformed_flows[key];
                }
                return obj;
              },
              {}
            ),
          };
        });

        console.log("new filteredFlows ::", filteredFlows);
      }

      filteredFlows = [
        ...filteredFlows,
        ...flows.filter((flow) => {
          return Object.keys(flow.transformed_flows).some((flowName) => {
            return flowName.toLowerCase().includes(searchValue.toLowerCase());
          });
        }),
      ];

      // remove dubplicates from filteredFlows
      filteredFlows = filteredFlows.filter((flow, index, self) => {
        return (
          index ===
          self.findIndex((t) => {
            return t._id === flow._id;
          })
        );
      });
    } else if (searchValue.length > 0) {
      // filter with brand and transformed_flows[x] and transformed_flows[x].version

      filteredFlows = flows.filter((flow) => {
        return flow.brand.toLowerCase().includes(searchValue.toLowerCase());
      });

      filteredFlows = [
        ...filteredFlows,
        ...flows.filter((flow) => {
          return Object.keys(flow.transformed_flows).some((flowName) => {
            return flowName.toLowerCase().includes(searchValue.toLowerCase());
          });
        }),
      ];

      // remove dubplicates from filteredFlows
      filteredFlows = filteredFlows.filter((flow, index, self) => {
        return (
          index ===
          self.findIndex((t) => {
            return t._id === flow._id;
          })
        );
      });
    }

    console.log("filteredFlows ::", filteredFlows);

    filterFlows(filteredFlows);
  };

  return (
    <div className={styles.search_container}>
      <input
        type="text"
        className={styles.search_input}
        ref={inputRef}
        onChange={handleSearch}
      />
    </div>
  );
};

export default Search;
